<template>
  <EmailComponentsBackupEmail />
</template>

<script>
export default {
    data() {
        return {
        }
    }
}
</script>
